module.exports = __webpack_public_path__ + "img/akitogogon-1.b0a432fc.jpg";